// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'umbrella';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.438 10.125a8.437 8.437 0 1 0-16.875 0l.608-.507a3.53 3.53 0 0 1 5.016.507 3.975 3.975 0 0 1 5.625 0 3.53 3.53 0 0 1 5.017-.507z' />
    <path d='M9 8.96v7.35a1.125 1.125 0 0 1-2.25 0M9 1.688V.563m8.01 11.887a1.426 1.426 0 0 0-2.063 0l-.884.91-.885-.91a1.427 1.427 0 0 0-2.063 0 1.545 1.545 0 0 0 0 2.134l2.633 2.723a.434.434 0 0 0 .629 0l2.633-2.727a1.545 1.545 0 0 0 0-2.13z' />
  </g>
);

export const viewBox = '0 0 18 18';
